const zh = {
	dataMonitoring: '数据监控',
	run: '已运行',
	RAM: '内存',
	used: '已用',
	idle: '空闲',
	refresh: '刷新',
};

export default zh;
